import _ from 'lodash';
import { createSelector } from 'reselect';

export const getFormStepNumber = (state, formName) => state.form.formStep[formName] === undefined ? 1 : state.form.formStep[formName]
export const isFormCompleted = (state, formName) => state.form.formCompleted[formName] === undefined ? false : state.form.formCompleted[formName] 
